'use client';

import { c as _c } from "react/compiler-runtime";
import { useI18n } from '~/features/i18n';

/** "Gebaseerd op N deelnemers", the price basis the control card prints under
 * its price. The finetuning card states the group size once above the results
 * instead, so this is control-only. */
export const ActivityCardParticipantsDescription: React.FC<{
  numParticipants?: number;
}> = props => {
  const $ = _c(3);
  const i18n = useI18n();
  if (!props.numParticipants) {
    return null;
  }
  let t0;
  if ($[0] !== i18n || $[1] !== props.numParticipants) {
    t0 = i18n._("Based on {amount} participants", {
      amount: props.numParticipants
    });
    $[0] = i18n;
    $[1] = props.numParticipants;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};